<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <page-title :title="'Histórico de  chamadas'"
                            :subtitle="'Informações e estatistica relativas ao registo de todas as chamadas na rede.'"/>
            </v-col>
        </v-row>

        <!-- FILTERS -->
        <v-row v-if="!loading && User.getters.writePermission('customer-service/calls')">
            <!-- COL FILTERS TO APPLY TO TABLE -->
            <v-col cols="2" style="display: flex; flex-direction: column;">
                <!-- DATES -->
                <v-row>
                    <v-col class="container-dates ml-4 mb-1">
                        <div>
                            <h4>Intervalo de datas</h4>
                            <v-divider class="mb-2"></v-divider>
                        </div>
                        <!-- SELECIONAR INTERVALO DE DATAS -->
                        <div class="dates-interval-container">
                            <v-menu
                                    v-model="menuSelectStartDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="inputSelectedStartDate"
                                            label="Data Inicial"
                                            prepend-icon="mdi-calendar"
                                            readonly hide-details
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="loading"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                        v-model="inputSelectedStartDate"
                                        @input="menuSelectStartDate = false;"
                                        locale="pt-PT"
                                        :max="inputSelectedEndDate"
                                ></v-date-picker>
                            </v-menu>

                            <v-menu
                                    v-model="menuSelectEndDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="inputSelectedEndDate"
                                            label="Data Final"
                                            prepend-icon="mdi-calendar"
                                            readonly hide-details
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="loading"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                        v-model="inputSelectedEndDate"
                                        @input="menuSelectEndDate = false;"
                                        locale="pt-PT"
                                        :max="new Date().toISOString().split('T')[0]"
                                ></v-date-picker>
                            </v-menu>
                        </div>

                        <!-- UPDATE VALUES -->
                        <v-btn small width="100%" class="mt-2" color="info" @click="updateValues">
                            <v-icon size="20" class="mr-1">mdi-update</v-icon>
                            Atualizar
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- FILTERS -->
                <v-row>
                    <v-col class="ml-4" style="border: 1px solid rgba(0,0,0,0.2); background-color: rgba(0,0,0,0.04)">
                        <h4>Filtros</h4>
                        <v-divider class="mb-2"></v-divider>
                        <!-- VISUALIZAR CHAMADAS INTERNAS -->
                        <v-btn tile x-small :color="seeInternalCalls ? 'success' : ''" @click="changeViewInternalCalls"
                               class="ml-1 mr-1" :disabled="loading"> Chamadas Internas
                        </v-btn>
                        <v-btn tile x-small :color="seeOutboundCalls ? 'success' : ''" @click="changeViewOutboundCalls"
                               class="ml-1 mr-1" :disabled="loading"> Chamadas Efetuadas
                        </v-btn>
                        <v-btn tile x-small :color="seeInboundCalls ? 'success' : ''" @click="changeViewInboundCalls"
                               class="ml-1 mr-1" :disabled="loading"> Chamadas Recebidas
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>

            <!-- COL STATS TOTAIS -->
            <v-col cols="3">
                <h3 class="text-center">Totais chamadas</h3>
                <!-- TOTAL | EXTERNAS | INTERNAS -->
                <div style="display: flex; align-items: center; justify-content: center">
                    <v-row>
                        <v-col cols="12" style="display: flex; align-items: center; justify-content: center">
                            <v-card
                                    style="min-width: 120px; height: 80px; border-radius: 4px 4px 0 0;"
                                    color="grey"
                                    class="mt-2 mb-2"
                            >
                                <v-card-text class="card-totals">
                                    <h2>{{ totalCalls }}</h2>
                                </v-card-text>
                                <v-card-actions class="pt-1 pb-1 card-totals-actions">
                                    <p class="mb-0 label-totals" style="font-weight: bold">Total</p>
                                </v-card-actions>
                            </v-card>

                            <v-card
                                    class="ml-2 mt-2 mb-2"
                                    style="min-width: 120px; height: 80px; border-radius: 4px 4px 0 0;"
                                    color="info"
                            >
                                <v-card-text class="card-totals">
                                    <h2>{{ totalExternalCalls }}</h2>
                                </v-card-text>
                                <v-card-actions class="pt-1 pb-1 card-totals-actions">
                                    <p class="mb-0 label-totals" style="font-weight: bold">Externas</p>
                                </v-card-actions>
                            </v-card>

                            <v-card
                                    class="ml-2 mt-2 mb-2"
                                    style="min-width: 120px; height: 80px; border-radius: 4px 4px 0 0;"
                                    color="#e8daef"
                            >
                                <v-card-text class="card-totals">
                                    <h2>{{ totalInternalCalls }}</h2>
                                </v-card-text>
                                <v-card-actions class="pt-1 pb-1 card-totals-actions"
                                                style="border-color: #e8daef !important;">
                                    <p class="mb-0 label-totals" style="font-weight: bold">Internas</p>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" style="display: flex; align-items: center; justify-content: center">
                            <v-card
                                    class="mt-2 mb-2"
                                    style="min-width: 120px; height: 80px; border-radius: 4px 4px 0 0;"
                                    color="green"
                            >
                                <v-card-text class="card-totals">
                                    <h2>{{ totalAnswered }}</h2>
                                </v-card-text>
                                <v-card-actions class="pt-1 pb-1 card-totals-actions">
                                    <p class="mb-0 label-totals" style="font-weight: bold">Atendidas</p>
                                </v-card-actions>
                            </v-card>

                            <v-card
                                    class="ml-2 mt-2 mb-2"
                                    style="min-width: 120px; height: 80px; border-radius: 4px 4px 0 0;"
                                    color="red"
                            >
                                <v-card-text class="card-totals">
                                    <h2>{{ totalNoAnswered }}</h2>
                                </v-card-text>
                                <v-card-actions class="pt-1 pb-1 card-totals-actions">
                                    <p class="mb-0 label-totals" style="font-weight: bold">Não Atendidas</p>
                                </v-card-actions>
                            </v-card>

                            <v-card
                                    class="ml-2 mt-2 mb-2"
                                    style="min-width: 120px; height: 80px; border-radius: 4px 4px 0 0;"
                                    color="yellow"
                            >
                                <v-card-text class="card-totals">
                                    <h2>{{ totalOtherStates }}</h2>
                                </v-card-text>
                                <v-card-actions class="pt-1 pb-1 card-totals-actions">
                                    <p class="mb-0 label-totals" style="font-weight: bold">Outros</p>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-col>

            <!-- COL MORE STATS BY EXTENSION -->
            <v-col cols="6" class="container-dates">
                <h4 class="text-center">Estatistica extensões</h4>
                <v-row>
                    <v-col style="display: flex; align-items: center; max-width: 380px;">
                        <GChart
                                v-if="!loading"
                                class="question-chart"
                                type="PieChart"
                                :data="chartData"
                                :options="chartOptions"
                        />
                    </v-col>
                    <v-col>
                        <v-simple-table dense class="mt-2" style="background-color: rgba(0,0,0,0.08)">
                            <thead>
                            <tr>
                                <td class="font-weight-bold" width="40%">Nome</td>
                                <td class="text-center font-weight-bold">Total</td>
                                <td class="text-center font-weight-bold">Tempo</td>
                                <td class="text-center font-weight-bold">Tempo médio</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(extensionStat, key) in Object.values(callsByExtension)" :key="key"
                                v-if="key < 8">
                                <td>{{ extensionStat.extension }}</td>
                                <td class="text-center">{{ extensionStat.calls }}</td>
                                <td class="text-center">{{ extensionStat.time }}s</td>
                                <td class="text-center">{{ extensionStat.media }}s</td>
                            </tr>
                            </tbody>
                        </v-simple-table>

                    </v-col>
                </v-row>
            </v-col>

            <!-- COL TABLE COLORS MAP -->
            <v-col cols="1" style="display: flex; justify-content: center;background-color: white;">
                <div class="table-colors-explain">
                    <h5 class="pl-1 pb-2 text-center">Mapa Cores Tabela</h5>

                    <p class="mb-2 pt-1 pl-2 table-colors-explain-labels">
                        <v-icon size="18" class="pr-1">mdi-call-received</v-icon>
                        Recebidas
                        <v-icon color="#d4edda" size="18" class="pr-1">mdi-square</v-icon>
                    </p>
                    <p class="mb-2 pt-1 pl-2 table-colors-explain-labels">
                        <v-icon size="18" class="pr-1">mdi-call-made</v-icon>
                        Efetuadas
                        <v-icon color="#d6eaf8" size="18" class="pr-1">mdi-square</v-icon>
                    </p>
                    <p class="mb-2 pt-1 pl-2 table-colors-explain-labels">
                        <v-icon size="18" class="pr-1">mdi-call-missed</v-icon>
                        Perdidas
                        <v-icon color="#fdecea" size="18" class="pr-1">mdi-square</v-icon>
                    </p>
                    <p class="mb-2 pt-1 pl-2 table-colors-explain-labels">
                        <v-icon size="18" class="pr-1">mdi-call-split</v-icon>
                        Internas
                        <v-icon color="#e8daef" size="18" class="pr-1">mdi-square</v-icon>
                    </p>

                </div>
            </v-col>
        </v-row>


        <!-- TABLE LIST OF CALLS -->
        <v-row>
            <v-col cols="12" class="pb-0 text-center">
                <v-divider class="mt-2 mb-2"></v-divider>
                <!--                <h2>LISTA DE CHAMADAS</h2>-->
            </v-col>
            <v-col>
                <!--                <p v-if="callsRegistry.length > 0" v-for="call in callsRegistry">{{call}}</p>-->
                <v-simple-table
                        v-if="callsRegistry.length > 0" dense
                        class="staff_table"
                >
                    <thead>
                    <tr>
                        <th>Data</th>
                        <th>Source</th>
                        <th>Destination</th>
                        <th class="text-center">Cliente</th>
                        <!--                            <th>CallerID</th>-->
                        <!--                        <th>Channel</th>-->
                        <!--                        <th>Dest.Channel</th>-->
                        <th class="text-center">Duration</th>
                        <th class="text-center">CallDuration</th>
                        <th class="text-center">State</th>
                        <th class="text-center">Extensao</th>
<!--                        <th>DID</th>-->
                        <th class="text-center" width="5%">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!-- LOADING CALLS -->
                    <tr v-if="loading">
                        <td colspan="10" class="text-center pa-10">
                            <v-progress-circular
                                    indeterminate
                                    color="error"
                            ></v-progress-circular>
                        </td>
                    </tr>

                    <!-- FILTERS ROW -->
                    <tr v-if="!loading" class="filters_row">
                        <td>
                            <v-text-field
                                    v-model="filters.date"
                                    outlined
                                    hide-details
                                    single-line
                                    @keyup="filteredLines"
                            >
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                    v-model="filters.source"
                                    outlined
                                    hide-details
                                    single-line
                                    @keyup="filteredLines"
                            >
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                    v-model="filters.destination"
                                    outlined
                                    hide-details
                                    single-line
                                    @keyup="filteredLines"
                            >
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                    v-model="filters.clientCode"
                                    outlined
                                    hide-details
                                    single-line
                                    @keyup="filteredLines"
                            >
                            </v-text-field>
                        </td>
                        <!--                        <td></td>-->
                        <td></td>
                        <td></td>
                        <td style="max-width: 100px">
                            <v-select
                                    v-model="filters.state"
                                    :items="callStates"
                                    item-text="title"
                                    item-value="value"
                                    outlined
                                    hide-details
                                    dense
                                    @change="filteredLines"
                            ></v-select>
                        </td>
                        <td>
                            <v-text-field
                                    v-model="filters.extension"
                                    outlined
                                    hide-details
                                    single-line
                                    @keyup="filteredLines"
                            >
                            </v-text-field>
                        </td>
<!--                        <td></td>-->
                        <td></td>
                    </tr>

                    <!-- TABELA COM LISTA DE CHAMADAS  -->
                    <tr v-if="!loading" v-for="(call, key) in filteredCalls"
                        :class="[call.src.length < 4 && call.dst.length < 4 ? 'internal-call-row' : (call.src === '244575195' ? 'outbound-call-row' : 'inbound-call-row')]"
                        :style="[call.disposition === 'NO ANSWER' ? {'background-color': '#fdecea !important'} : '']"
                    >
                        <td class="pl-2"
                            :class="[call.disposition === 'NO ANSWER' ? 'col-call-lost' : (call.disposition === 'ANSWERED' ? 'col-call-answered' : 'col-call-other')]"
                        >
                            <span class="line-number mr-4">{{ filteredCalls.length - key }}</span> {{ call.calldate }}
                        </td>
                        <td>
                            <v-chip
                                    v-if="call.src.length < 4"
                                    color="info"
                                    x-small
                            >
                                {{ call.src }} - INTERNAL
                                <!--                                <strong class="pl-1" style="font-size: 14px">{{ call.src }}</strong>-->
                            </v-chip>
                            <v-chip
                                    v-else-if="call.src === '244575195'"
                                    color="success"
                                    x-small
                            >
                                <strong class="pl-1" style="">{{ call.src }} </strong>
                                - BICIMAX
                            </v-chip>
                            <span v-else style="display: flex; align-items: center;">
                                    <v-icon size="18">
                                        mdi-account
                                    </v-icon>
                                    {{ call.src }}
                            </span>
                        </td>
                        <td>
                            <v-chip
                                    v-if="call.dst === 's' "
                                    color="warning"
                                    x-small
                            >
                                FORA DE HORARIO DE SERVIÇO
                            </v-chip>
                            <v-chip
                                    v-else-if="call.dst === 'FORA DE HORARIO DE SERVIÇO'"
                                    color="warning"
                                    x-small
                            >
                                FORA DE HORARIO DE SERVIÇO
                            </v-chip>
                            <v-chip
                                    v-else-if="call.dst === '200'"
                                    color="purple"
                                    x-small
                                    style="color: white"
                            >
                                {{ call.dst }} - ATENCAO CLIENTE
                            </v-chip>
                            <v-chip
                                    v-else-if="call.dst.length < 4 && call.dst != '200'"
                                    color="info"
                                    x-small
                            >
                                {{ call.dst }} - INTERNAL
                                <!--                                <strong class="pl-1" style="font-size: 14px">{{ call.dst }}</strong>-->
                            </v-chip>
                            <v-chip
                                v-else-if="call.dcontext === 'app-backhole' && call.dst === 'hangup'"
                                color="error"
                                x-small
                            >
                                {{ call.dst }} - NO AWNSER
                            </v-chip>
                            <span v-else>
                                {{ call.dst }}
                            </span>
                        </td>
                        <!--                                                    <td>{{call.clid}}</td>-->
                        <td class="text-center">{{call.clientCode}}</td>
                        <!--                        <td>{{ call.channel }}</td>-->
                        <!--                        <td>{{ call.dstchannel }}</td>-->
                        <td class="text-center">{{ call.duration }}s</td>
                        <td class="text-center">{{ call.billsec }}s</td>
                        <td class="text-center">
                            <!-- ESTADO DO CHAMADA -->
                            <v-chip
                                    v-if="call.disposition === 'NO ANSWER'"
                                    color="error"
                                    small
                            >
                                {{ call.disposition }}
                            </v-chip>
                            <v-chip
                                    v-else-if="call.disposition === 'ANSWERED'"
                                    color="success"
                                    small
                            >
                                {{ call.disposition }}
                            </v-chip>
                            <v-chip
                                    v-else
                                    color="warning"
                                    small
                            >
                                {{ call.disposition }}
                            </v-chip>
                        </td>
                        <td class="text-center">
                            <v-chip
                                    v-if="call.dst === '200' && call.disposition === 'NO ANSWER'"
                                    color="purple"
                                    x-small
                                    style="color: white"
                            >
                                {{ call.dst }} - ATENCAO CLIENTE
                            </v-chip>
                            <span v-else>
                                {{ call.dst.length < 4 && call.src.length < 4 ? call.dst : call.extensao }}
                            </span>
                        </td>
<!--                        <td>-->
<!--                            {{ call.did === '1234501' ? '34911231593 / 34919014578' : call.did }}-->
<!--                        </td>-->
                        <td class="text-center">
                            <v-btn x-small tile @click="openCallInfo(call)">
                                Mais Info
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>

        <!-- DIALOG CALL INFO -->
        <v-dialog
                persistent
                v-model="dialogCallInfo"
                max-width="1200"
        >
            <v-card>
                <Call v-if="dialogCallInfo" :callID="selectedCall.uniqueid" :call="selectedCall" v-on:new-interaction-call="selectCallToNewInteraction(selectedCall)"/>
                <v-card-actions style="display: flex; justify-content: center; align-items: center">
                    <v-btn color="info" small width="250px" @click="dialogCallInfo = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- DIALOG NEW INTERACTION CALL -->
        <v-dialog
            persistent
            v-model="modalNewCall"
            max-width="1200"
        >
            <v-card>
                <NewCall v-if="modalNewCall" :chamadaAtual="newCallInteraction" v-on:close-new-call="modalNewCall=false;newCallInteraction={};"/>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import Issabel from "@/models/Issabel";
import Call from './Call.vue';
import NewCall from './NewCall.vue';
import io from "socket.io-client";
import User from "@/models/User";

export default {
    computed: {
        User() {
            return User
        }
    },
    components: {Call, NewCall},
    data: () => ({
        loading: false,
        callsRegistry: [],
        filteredCalls: [],
        menuSelectDate: false,
        inputSelectedDate: '',
        menuSelectStartDate: false,
        inputSelectedStartDate: '',
        menuSelectEndDate: false,
        inputSelectedEndDate: '',
        totalCalls: 0,
        totalAnswered: 0,
        totalNoAnswered: 0,
        totalOtherStates: 0,
        totalInternalCalls: 0,
        totalExternalCalls: 0,
        seeInternalCalls: true,
        seeOutboundCalls: true,
        seeInboundCalls: true,
        callsByExtension: [],
        chartOptions: {
            // 'title': 'Estatistica Chamadas',
            'height': '100%',
            'legend': 'none',
            'titleTextStyle': {
                fontSize: 16,
                bold: true
            },
            animation: {
                startup: true,
                duration: 800,
                easing: 'out'
            },
            chartArea: {
                // left:20,
                // top:0,
                width: '100%',
                height: '93%'
            },
            pieHole: 0.2,
            backgroundColor: 'transparent'
            // ,sliceVisibilityThreshold: .1
        },
        chartData: [
            ['Extensão', 'Chamadas']
        ],
        filters: {
            date: '',
            source: '',
            destination: '',
            state: '',
            extension: '',
            clientCode: ''
        },
        callStates: [
            {title: 'All', value: ''},
            {title: 'ANSWERED', value: 'ANSWERED'},
            {title: 'NO ANSWER', value: 'NO ANSWER'},
            {title: 'FAILED', value: 'FAILED'},
            {title: 'FECHADO', value: 'FECHADO'},
            {title: 'BUSY', value: 'BUSY'}
        ],
        dialogCallInfo: false,
        selectedCall: '',
        newCallInteraction: {
                tipoChamada: "",
                agente: "",
                numeroCliente: "",
                extensao: "",
                canais: [],
                linkedId: "",
                timestamp: ""
        },
        modalNewCall: false
    }),
    created() {
        // this.webSocketWaitingCalls()
    },
    mounted() {
        //Get day
        this.inputSelectedDate = new Date().toISOString().split('T')[0];
        this.inputSelectedStartDate = new Date().toISOString().split('T')[0];
        this.inputSelectedEndDate = new Date().toISOString().split('T')[0];
        //Initialize values
        this.getCalls();
    },
    methods: {
        getCalls() {
            this.loading = true;
            //clear filters
            this.clearFilters();

            //Prepare data to send
            let callsDates = {
                day: this.inputSelectedDate,
                startDate: this.inputSelectedStartDate,
                endDate: this.inputSelectedEndDate,
                internalCalls: this.seeInternalCalls,
                outboundCalls: this.seeOutboundCalls,
                inboundCalls: this.seeInboundCalls
            }

            //Make request
            Issabel.dispatch('getCalls', callsDates)
                    .then(response => {
                        let responseData = response.data;

                        // console.log(responseData);
                        this.callsRegistry = responseData;

                        // validate calls dont answered by customer_service with extension 200
                        for (const call of this.callsRegistry) {
                            if (call.dst === '200' && call.disposition === 'NO ANSWER') {
                                call.extensao = '200';
                            }
                        }

                        // tratar dos dados
                        // const callsFiltered = [];
                        // const callById = {};
                        //
                        // this.callsRegistry.forEach(call => {
                        //     const id = call.uniqueid;
                        //     if (!callById[id]) callById[id] = [];
                        //     callById[id].push(call);
                        // });
                        //
                        // Object.values(callById).forEach(lista => {
                        //     // Tenta encontrar uma chamada atendida
                        //     const atendida = lista.find(l => l.disposition === 'ANSWERED');
                        //     if (atendida) {
                        //         callsFiltered.push(atendida);
                        //     } else {
                        //         // Caso nenhuma atendida, escolhe a mais recente
                        //         const ordenadas = lista.sort((a, b) => new Date(b.calldate) - new Date(a.calldate));
                        //         if (ordenadas[0].dst === 'hangup'){
                        //             callsFiltered.push(ordenadas[1]);
                        //         }else {
                        //             callsFiltered.push(ordenadas[0]);
                        //         }
                        //     }
                        // });

                        // this.filteredCalls = this.callsRegistry;
                        this.removeDuplicatedLines();
                        this.updateTotals();
                        this.filteredChart();

                        this.loading = false;
                    })
                    .catch(response => {
                        console.log('ERROR: ' + response);
                        this.loading = false;
                    })
        },
        changeViewInternalCalls() {
            this.seeInternalCalls = !this.seeInternalCalls;
            //Update Values
            this.updateValues();
        },
        changeViewOutboundCalls() {
            this.seeOutboundCalls = !this.seeOutboundCalls;
            //Update Values
            this.updateValues();
        },
        changeViewInboundCalls() {
            this.seeInboundCalls = !this.seeInboundCalls;
            //Update Values
            this.updateValues();
        },
        updateValues() {
            //Clear Totals
            this.totalCalls = 0;
            this.totalAnswered = 0;
            this.totalNoAnswered = 0;
            this.totalOtherStates = 0;
            this.totalExternalCalls = 0;
            this.totalInternalCalls = 0;
            //Clear Stats
            this.callsByExtension = [];
            //Clear Charts
            this.chartData = [
                ['Extensão', 'Chamadas']
            ]
            //Update Values
            this.getCalls();
            // this.getStats();
        },
        removeDuplicatedLines() {
            /****
             ** Function to remove duplicates
             * Para conseguir agarrar apenas uma linha por chamdada. Tendo em conta que toca em vários qnd chega a chamada do cliente
             ****/
            let auxList = this.callsRegistry;

            const chamadasFiltradas = [];
            const chamadasPorId = {};

            auxList.forEach(linha => {
                const id = linha.uniqueid + '_' + linha.clid;
                if (!chamadasPorId[id]) chamadasPorId[id] = [];
                chamadasPorId[id].push(linha);
            });

            Object.values(chamadasPorId).forEach(lista => {
                // Tenta encontrar uma chamada atendida
                const atendida = lista.find(l => l.disposition === 'ANSWERED');
                if (atendida) {
                    //Apesar de estado = atendida, validar se foi fora do horário de trabalho
                    if (!this.checkDentroDoHorario(atendida.calldate) && atendida.dst === 'hangup'){
                        atendida.disposition = 'FECHADO'
                        atendida.dst = 'FORA DE HORARIO DE SERVIÇO'
                    }

                    chamadasFiltradas.push(atendida);
                } else {
                    // Caso nenhuma atendida, escolhe a mais recente
                    const ordenadas = lista.sort((a, b) => new Date(b.calldate) - new Date(a.calldate));

                    if (ordenadas[0].dst === 'hangup' && this.checkDentroDoHorario(ordenadas[0].calldate)){
                        //Mostra a Não atendida
                        chamadasFiltradas.push(ordenadas[1]);
                    }else {
                        //Devolve hangup mesmo, pois é fora do horário laboral
                        if (!this.checkDentroDoHorario(ordenadas[0].calldate) && ordenadas[0].src !== '244575195'){
                            ordenadas[0].disposition = 'FECHADO'
                            ordenadas[0].dst = 'FORA DE HORARIO DE SERVIÇO'
                        }
                        // console.log(ordenadas[0].calldate)
                        chamadasFiltradas.push(ordenadas[0]);
                    }
                }
            });

            this.filteredCalls = chamadasFiltradas;
        },
        filteredLines() {
            // this.filteredCalls = this.callsRegistry;
            this.removeDuplicatedLines();
            if (this.filters.date !== '') {
                this.filteredCalls = this.filteredCalls.filter(item => item.calldate.toUpperCase().includes(this.filters.date.toUpperCase()))
            }
            if (this.filters.source !== '') {
                this.filteredCalls = this.filteredCalls.filter(item => item.src.toUpperCase().includes(this.filters.source.toUpperCase()))
            }
            if (this.filters.destination !== '') {
                this.filteredCalls = this.filteredCalls.filter(item => item.dst.toUpperCase().includes(this.filters.destination.toUpperCase()))
            }
            if (this.filters.state !== '') {
                this.filteredCalls = this.filteredCalls.filter(item => item.disposition.toUpperCase().includes(this.filters.state.toUpperCase()))
            }
            if (this.filters.extension !== '') {
                this.filteredCalls = this.filteredCalls.filter(item => item.extensao.toUpperCase().includes(this.filters.extension.toUpperCase()))
            }
            if (this.filters.clientCode !== '') {
                this.filteredCalls = this.filteredCalls.filter(item => item.clientCode ? item.clientCode.toUpperCase().includes(this.filters.clientCode.toUpperCase()) : '')
            }
            // this.items = this.itemsFiltered.slice(0, 100);
            this.updateTotals();
            this.filteredChart();
        },
        filteredChart() {
            const callsByExtensionChart = {}
            this.chartData = [
                ['Extensão', 'Chamadas']
            ];

            this.filteredCalls.forEach((call) => {
                const user = call.extensao
                // ONLY list on graph and table if extension have user associated
                if (user != '200' && user != '' && call.disposition === 'ANSWERED') {
                    if (!callsByExtensionChart[user]) {
                        callsByExtensionChart[user] = [];
                        callsByExtensionChart[user] = {calls: 0, time: 0, media: 0, extension: user};
                        //call info
                        callsByExtensionChart[user].calls += 1;
                        callsByExtensionChart[user].time += call.billsec;
                        callsByExtensionChart[user].media = parseFloat(callsByExtensionChart[user].time / callsByExtensionChart[user].calls).toFixed(2);
                    } else {
                        //Add call info
                        callsByExtensionChart[user].calls += 1;
                        callsByExtensionChart[user].time += call.billsec;
                        callsByExtensionChart[user].media = parseFloat(callsByExtensionChart[user].time / callsByExtensionChart[user].calls).toFixed(2);
                    }
                }
            })

            //Fill chart data
            for (const user in callsByExtensionChart) {
                this.chartData.push([callsByExtensionChart[user].extension, callsByExtensionChart[user].calls])
            }
            //Save values to show table - + order lines
            this.callsByExtension = Object.entries(callsByExtensionChart)
                    .sort(([, a], [, b]) => JSON.parse(b.calls) - JSON.parse(a.calls))
                    .reduce((obj, [key, val]) => {
                        obj[key] = val
                        return obj;
                    }, {});

            //Debug
            // console.log(callsByExtensionChart);
            // console.log(this.chartData);
        },
        updateTotals() {
            this.totalCalls = this.filteredCalls.length;
            //Reset Values
            this.totalAnswered = 0;
            this.totalNoAnswered = 0;
            this.totalOtherStates = 0;
            this.totalExternalCalls = 0;
            this.totalInternalCalls = 0;

            for (const call of this.filteredCalls) {
                if (call.disposition === 'ANSWERED') {
                    this.totalAnswered += 1;
                }
                if (call.disposition === 'NO ANSWER') {
                    this.totalNoAnswered += 1;
                }
                if (call.disposition !== 'ANSWERED' && call.disposition !== 'NO ANSWER') {
                    this.totalOtherStates += 1;
                }

                //Se chamada a partir de fora, ou a partir do numero da bicimax
                if (call.dcontext !== 'from-internal' || call.src === '244575195') {
                    this.totalExternalCalls += 1;
                } else {
                    this.totalInternalCalls += 1;
                }
            }
        },
        clearFilters() {
            this.filters = {
                date: '',
                source: '',
                destination: '',
                state: '',
                extension: '',
                clientCode: ''
            }
        },
        openCallInfo(call) {
            this.selectedCall = call;

            this.dialogCallInfo = true;
        },
        checkDentroDoHorario(data) {
            // Extrair a hora da string "2025-08-07 16:12:14"
            const horaString = data.split(' ')[1]; // "16:12:14"
            const [hora, minuto, segundo] = horaString.split(':').map(Number);

            const totalSegundos = hora * 3600 + minuto * 60 + segundo;

            // Definir intervalos válidos em segundos desde a meia-noite
            const inicioManha = 9 * 3600;     // 09:00:00
            const fimManha = 13 * 3600;       // 13:00:00
            const inicioTarde = 14 * 3600;    // 14:00:00
            const fimTarde = 18 * 3600;       // 18:00:00

            // Validar se está dentro de um dos dois intervalos
            return (
                    (totalSegundos >= inicioManha && totalSegundos < fimManha) ||
                    (totalSegundos >= inicioTarde && totalSegundos < fimTarde)
            );
        },
        checkIfCustomerService(loggedEmail){
            let userExtension = '';

            switch (loggedEmail) {
                case 'daniel.pereira@bicimax.pt':
                    userExtension = '11';
                    break;
                case 'nuno.jorge@bicimax.pt':
                    userExtension = '13';
                    break;
                case 'lizeth.mobile@bicimax.pt':
                    userExtension = '15'
                    break;
                case 'jaime.ortega@bicimax.pt':
                    userExtension = '16'
                    break;
                case 'gustavo.urbano@bicimax.pt':
                    userExtension = '998'
                    break;
            }

            return userExtension;
        },
        selectCallToNewInteraction(selectedCall){
            //Fechar dialog callInfo
            this.dialogCallInfo = false

            //Fill data to new call_interaction
            //formatar extensao para dividir a extensao e o nome do agente
            const auxExtension = selectedCall.extensao.split(' - ');
            this.newCallInteraction.extensao = auxExtension[0]
            this.newCallInteraction.agente = auxExtension[1]
            this.newCallInteraction.linkedId = selectedCall.uniqueid
            this.newCallInteraction.timestamp = selectedCall.calldate
            this.newCallInteraction.canais = []

            //Validar se recebida, efetuada ou interna
            if (selectedCall.src === '244575195'){
                this.newCallInteraction.tipoChamada = 'efetuada'
                this.newCallInteraction.numeroCliente = selectedCall.dst
            }
            else{
                this.newCallInteraction.tipoChamada = 'recebida'
                this.newCallInteraction.numeroCliente = selectedCall.src
            }

            //Open dialog new call
            this.modalNewCall = true;
        }
    }
}

</script>
<style>
.internal-call-row {
    background-color: #e8daef;
}

.outbound-call-row {
    background-color: #d6eaf8;
}

.inbound-call-row {
    background-color: #d4edda;
}

.container-dates {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: rgba(0, 0, 0, 0.04)
}

.table-colors-explain {
    background-color: white;
    padding: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.table-colors-explain-labels {
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card-totals {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80px;
}

.label-totals {
    font-size: 13px;
}

.card-totals-actions {
    display: flex;
    justify-content: center;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.col-call-lost {
    border-left: 2px solid #e53935 !important;
}

.col-call-answered {
    border-left: 2px solid #43a047 !important;
}

.col-call-other {
    border-left: 2px solid #fbc02d !important;
}

.line-number {
    padding: 4px;
    background-color: rgba(0, 0, 0, 0.2);
    color: rgba(0, 0, 0, 0.7);
    font-weight: 600;
}
</style>